import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { usePortal } from '../../contexts/PortalContext';
import { relativeTime } from '../../utils/time';
export function ActivityFeed({
  limit = 8
}: {
  limit?: number;
}) {
  const {
    activity,
    openActivity
  } = usePortal();
  const rows = activity.slice(0, limit);
  return <section aria-labelledby="activity" data-id="element-131" data-mp="c338mczpa3xp">
      <div className="border-b border-ruleDark pb-4" data-id="element-132" data-mp="c6h9fgspu531">
        <h2 id="activity" className="label m-0 text-paper/40" data-id="element-133" data-mp="r0dgzdh1qtp7">
          Recent Activity
        </h2>
      </div>

      <ul className="m-0 list-none p-0" data-id="element-134" data-mp="m1sok081debb">
        {rows.length === 0 && <li className="py-6 font-display text-lg text-paper/40" data-id="element-135" data-mp="zsnp8p8dsp3t">No client activity yet.</li>}
        {rows.map(entry => <li key={entry.id} className="border-b border-ruleDark" data-id="element-136" data-mp="vsx0ss6bul2g">
            <button type="button" onClick={() => openActivity(entry)} className="group flex w-full items-baseline justify-between gap-6 py-5 text-left" data-id="element-137" data-mp="19sy38c28q0k1">
              <span className="min-w-0" data-id="element-138" data-mp="3mpbpilb9v9tn">
                <span className="label-sm block text-paper/35" data-id="element-139" data-mp="3mqd06oodluau">{entry.projectName}</span>
                <span className="mt-2 block font-display text-lg leading-snug text-paper/90" data-id="element-140" data-mp="3rp7mw1pgs308">
                  {entry.actorName} {entry.action}
                </span>
                {entry.message && <span className="mt-2 block max-w-md font-display text-base italic leading-snug text-paper/50" data-id="element-141" data-mp="4g2kwd3ecite">
                    &ldquo;{entry.message}&rdquo;
                  </span>}
              </span>
              <span className="label-sm flex shrink-0 items-center gap-3 text-paper/35" data-id="element-142" data-mp="j6rxnjwia5zd">
                {relativeTime(entry.at)}
                <ArrowRightIcon className="h-3 w-3 opacity-0 transition-opacity duration-150 ease-out group-hover:opacity-100" strokeWidth={1.25} data-id="element-143" data-mp="o5389wumkkin" />
              </span>
            </button>
          </li>)}
      </ul>
    </section>;
}